module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.2d4d066a.jpeg";